/**
 * L'avatar d'un fil — la MÊME pastille ronde partout où l'on affiche une conversation, quel que
 * soit le canal (Telegram, X…). Extrait de `panels/fan/views.tsx` le 24-08-2026 ; depuis le lot 5
 * du catalogue (01-11-2026) c'est l'`Avatar` de la librairie, rond, avec la graine : une seule
 * pastille, une seule règle de repli. Décoratif (le nom est à côté, dans le fil).
 *
 *   <ChatAvatar src={fan.photo} seed={fan.id} size={28} />
 */
import { Avatar } from "./Avatar";

export function ChatAvatar({
  src,
  seed,
  size = 28,
}: {
  src?: string | null;
  /** Sert à dériver un avatar par défaut STABLE quand `src` manque ou casse. */
  seed: string;
  size?: number;
}) {
  return <Avatar src={src} graine={seed} taille={size} forme="rond" />;
}
